import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from "../../../headersService";


export const getPublicAnnouncementDetails = createAsyncThunk('getAnnouncementsDetails', async (id, { rejectWithValue }) => {
    try {
        const { data } = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL}/api/announcement/${id}`)
        return data
    } catch (error) {
        console.log(error)
        return rejectWithValue(error)
    }
})

export const publicAnnouncementDetailSlice = createSlice({
    name: 'Announcement Details',
    initialState: {
        loading: false,
        announcementDetail: null,
        error: null
    },
    extraReducers: (builder) => {
        builder.addCase(getPublicAnnouncementDetails.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(getPublicAnnouncementDetails.fulfilled, (state, action) => {
            state.loading = false;
            state.announcementDetail = action.payload
        })
        builder.addCase(getPublicAnnouncementDetails.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload
        })
    }
})
export default publicAnnouncementDetailSlice.reducer